module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'list') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.downloadRechnung()
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("download")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Rechnung herunterladen")])], 1) : _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "loading": _vm.loading,
            "rounded": "",
            "text": "",
            "icon": _vm.small
          },
          on: {
            "click": function($event) {
              return _vm.downloadRechnung()
            }
          }
        }, 'v-btn', attrs, false), on), [(_vm.icon) ? _c('v-icon', [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', [_vm._v(_vm._s(_vm.text))]) : _vm._e()], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Rechnung herunterladen")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd613cc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/rechnungDownload.vue
// module id = 824
// module chunks = 15